<template>
    <div style="text-align: center">
    <v-container v-if="!user || !user.displayName">
      <div class="title primary--text darken-1--text" v-if="!user || !user.displayName">
          Click the Sign-in button to Login
      </div>
    </v-container>
    <v-container v-else>
        <div v-if="user && !authorized">
            <div class="title primary--text darken-1--text">
                Please use your Jahnel Group email address to sign in.
                <br><br>
            </div>
            <router-link  to="/LandingPage" tag="span" style="cursor: pointer">
                <v-btn @click="signout" class="primary darken-2">
                Switch Accounts
                </v-btn>
            </router-link>
        </div>
        <this-month v-if="authorized"></this-month>
    </v-container>
    </div>
</template>

<script>
import { auth, signin, signout } from "@/vue-service-auth.js";
import ThisMonth from "./People/ThisMonth.vue";

export default {
  components: {
    "this-month": ThisMonth
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    authenticated() {
      return this.$store.getters.authenticated;
    },
    authorized() {
      return this.$store.getters.authorized;
    },
  },
  methods: {
    signin,
    signout
  }
};
</script>

<style scoped>
.secondary.v-card.v-sheet.theme--light {
    flex: 1 1 auto!important;
}
</style>



// WEBPACK FOOTER //
// src/components/LandingPage.vue